import i18next from 'i18next';

import ar from 'assets/flags/ar.png';
import bs from 'assets/flags/bs.png';
import bb from 'assets/flags/bb.png';
import bz from 'assets/flags/bz.png';
import bo from 'assets/flags/bo.png';
import br from 'assets/flags/br.png';
import cl from 'assets/flags/cl.png';
import co from 'assets/flags/co.png';
import cr from 'assets/flags/cr.png';
import ec from 'assets/flags/ec.png';
import sv from 'assets/flags/sv.png';
import gt from 'assets/flags/gt.png';
import gy from 'assets/flags/gy.png';
import ht from 'assets/flags/ht.png';
import hn from 'assets/flags/hn.png';
import jm from 'assets/flags/jm.png';
import mx from 'assets/flags/mx.png';
import ni from 'assets/flags/ni.png';
import pa from 'assets/flags/pa.png';
import py from 'assets/flags/py.png';
import pe from 'assets/flags/pe.png';
import dom from 'assets/flags/do.png';
import sr from 'assets/flags/sr.png';
import tt from 'assets/flags/tt.png';
import uy from 'assets/flags/uy.png';
import ve from 'assets/flags/ve.png';
import fr from 'assets/flags/fr.png';

export const COUNTRIES = [
  {
    id: 'argentina',
    label: i18next.t('countrySelector:argentina') as string,
    icon: ar,
  },
  {
    id: 'bahamas',
    label: i18next.t('countrySelector:bahamas') as string,
    icon: bs,
  },
  {
    id: 'barbados',
    label: i18next.t('countrySelector:barbados') as string,
    icon: bb,
  },
  {
    id: 'belice',
    label: i18next.t('countrySelector:belize') as string,
    icon: bz,
  },
  {
    id: 'bolivia',
    label: i18next.t('countrySelector:bolivia') as string,
    icon: bo,
  },
  {
    id: 'brasil',
    label: i18next.t('countrySelector:brasil') as string,
    icon: br,
  },
  {
    id: 'chile',
    label: i18next.t('countrySelector:chile') as string,
    icon: cl,
  },
  {
    id: 'colombia',
    label: i18next.t('countrySelector:colombia') as string,
    icon: co,
  },
  {
    id: 'costa rica',
    label: i18next.t('countrySelector:costa_rica') as string,
    icon: cr,
  },
  {
    id: 'ecuador',
    label: i18next.t('countrySelector:ecuador') as string,
    icon: ec,
  },
  {
    id: 'el salvador',
    label: i18next.t('countrySelector:el_salvador') as string,
    icon: sv,
  },
  {
    id: 'guatemala',
    label: i18next.t('countrySelector:guatemala') as string,
    icon: gt,
  },
  {
    id: 'guyana',
    label: i18next.t('countrySelector:guyana') as string,
    icon: gy,
  },
  {
    id: 'guyana francesa',
    label: i18next.t('countrySelector:french_guiana') as string,
    icon: fr,
  },
  {
    id: 'haiti',
    label: i18next.t('countrySelector:haiti') as string,
    icon: ht,
  },
  {
    id: 'honduras',
    label: i18next.t('countrySelector:honduras') as string,
    icon: hn,
  },
  {
    id: 'jamaica',
    label: i18next.t('countrySelector:jamaica') as string,
    icon: jm,
  },
  {
    id: 'mexico',
    label: i18next.t('countrySelector:mexico') as string,
    icon: mx,
  },
  {
    id: 'nicaragua',
    label: i18next.t('countrySelector:nicaragua') as string,
    icon: ni,
  },
  {
    id: 'panama',
    label: i18next.t('countrySelector:panama') as string,
    icon: pa,
  },
  {
    id: 'paraguay',
    label: i18next.t('countrySelector:paraguay') as string,
    icon: py,
  },
  {
    id: 'peru',
    label: i18next.t('countrySelector:peru') as string,
    icon: pe,
  },
  {
    id: 'republica dominicana',
    label: i18next.t('countrySelector:dominican_republic') as string,
    icon: dom,
  },
  {
    id: 'suriname',
    label: i18next.t('countrySelector:suriname') as string,
    icon: sr
  },
  {
    id: 'trinidad y tobago',
    label: i18next.t('countrySelector:trinidad_and_tobago') as string,
    icon: tt,
  },
  {
    id: 'uruguay',
    label: i18next.t('countrySelector:uruguay') as string,
    icon: uy,
  },
  {
    id: 'venezuela',
    label: i18next.t('countrySelector:venezuela') as string,
    icon: ve,
  },
  {
    id: 'africa',
    label: i18next.t('countrySelector:africa') as string,
    icon: undefined,
  },
  {
    id: 'america del norte',
    label: i18next.t('countrySelector:north_america') as string,
    icon: undefined,
  },
  {
    id: 'antartida',
    label: i18next.t('countrySelector:antartic') as string,
    icon: undefined,
  },
  {
    id: 'asia',
    label: i18next.t('countrySelector:asia') as string,
    icon: undefined,
  },
  {
    id: 'europa',
    label: i18next.t('countrySelector:europe') as string,
    icon: undefined,
  },
  {
    id: 'oceania',
    label: i18next.t('countrySelector:oceania') as string,
    icon: undefined,
  }
];
